import React from 'react';

interface SearchIconProps {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
}

const SearchIcon: React.FC<SearchIconProps> = ({ 
  width = 20, 
  height = 20, 
  color = '#222222',
  className,
  style 
}) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={width} 
      height={height} 
      fill="none" 
      viewBox="0 0 20 20"
      className={className}
      style={style}
    >
      <path 
        stroke={color} 
        strokeLinecap="round" 
        strokeLinejoin="round" 
        strokeWidth="1.2" 
        d="m12.222 12.222 4.445 4.445m-8.148-2.963a5.185 5.185 0 1 1 0-10.37 5.185 5.185 0 0 1 0 10.37"
      />
    </svg>
  );
};

export default SearchIcon;

